/* eslint-disable prefer-destructuring */
// @flow
import React, {
    useState, useEffect, useContext, useCallback,
} from 'react';
import {
    TextInput, Box, Form, FormField, Stack,
} from 'grommet';
import { Search } from 'grommet-icons/es6';
import { debounce } from 'lodash';
import { injectIntl, useIntl } from 'react-intl';
import { APIContext } from 'speed-js-react';
import TextInputWithDropdown from 'esm-web-pro/components/maps/TextInputWithDropdown';
import StyledCloseButtom from 'speed-js-react-web/src/components/grommet2/forms/fields/StyledCloseButton';

type Props = {
    currentMap?: Object,
}

const MapSearchField = (props: Props) => {
    const { currentMap } = props;

    const { apiClient } = useContext(APIContext);

    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState('');
    const [points, setPoints] = useState([]);
    const [lines, setLines] = useState([]);
    const [showMenu, setShowMenu] = useState(true);

    const handlePointSearch = useCallback(debounce((resource, query) => {
        apiClient.resources[resource].list(
            query,
        ).then((res) => {
            if (res.count) {
                if (resource === 'point11') {
                    setPoints(res.results);
                }
            } else {
                setPoints([]);
            }
        });
    }, 400), []);

    const handleLineSearch = useCallback(debounce((resource, query) => {
        apiClient.resources[resource].list(
            query,
        ).then((res) => {
            if (res.count) {
                if (resource === 'line') {
                    setLines(res.results);
                }
            } else {
                setLines([]);
            }
        });
    }, 400), []);

    const handleClearSearch = () => {
        setSearchTerm('');
        setPoints([]);
        setLines([]);
    };

    const handleDropDownItemClick = () => {
        setShowMenu(false);
    };

    useEffect(() => {
        if (searchTerm.length > 2) {
            const refs = searchTerm.toLocaleLowerCase().match(/тс\d+|ст\d+|шх\d+|нт\d+|тц\d+|рз\d+|пт\d+/gm);
            let type = [];
            type = refs?.join().match(/[\u0410-\u044f]+/g);
            let termNumbers = searchTerm?.match(/\d+/g);

            if (!type) {
                type = [''];
            }

            if (!termNumbers) {
                termNumbers = [0];
            }

            if (refs && refs.length) {
                handlePointSearch('point11', {
                    search: termNumbers[0],
                    type: type[0].toLocaleLowerCase(),
                    map: currentMap.identity,
                });
            } else {
                handlePointSearch('point11', {
                    search: searchTerm,
                    map: currentMap.identity,
                });
            }
            
            const lineQuery = {
                search: searchTerm,
                map: currentMap.identity,
            };

            if (type[0]) {
                lineQuery.type = type[0].toLocaleLowerCase();
            }


            if (type[1]) {
                lineQuery.secondType = type[1].toLocaleLowerCase();
            }

            handleLineSearch('line', lineQuery);
        } else if (searchTerm.length === 0) {
            setPoints([]);
            setLines([]);
        }
    }, [searchTerm, currentMap.identity]);

    React.useEffect(() => {
        const handleBodyClick = (e) => {
            if (
                e.target.id !== 'text-search-id'
                && !(
                    e.target.classList.contains('map-search-dropdown-item')
                    || (e.target.parentNode && e.target.parentNode.classList.contains('map-search-dropdown-item'))
                )
            ) {
                setShowMenu(false);
            }
        };
        document.body.addEventListener('click', handleBodyClick);

        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);

    return (
        <Box width="100%" id="map-search-container">
            <Form
                onChange={(event) => setSearchTerm(event.search)}
                style={{ border: null }}
            >
                <FormField
                    name="search"
                    htmlFor="text-search-id"
                >
                    <Stack anchor="right">
                        <TextInput
                            id="text-search-id"
                            name="search"
                            icon={<Search />}
                            placeholder={intl.formatMessage({ id: 'search-text' })}
                            style={{ paddingLeft: '2rem', backgroundColor: 'white' }}
                            value={searchTerm}
                            onClick={() => setShowMenu(true)}
                        />
                        {searchTerm.length > 0 && (
                            <StyledCloseButtom
                                onClick={handleClearSearch}
                                plain
                            />
                        )}
                    </Stack>
                </FormField>
                {((points.length > 0 || lines.length > 0) && showMenu) && (
                    <Box
                        style={{
                            zIndex: 100000,
                            border: points.length ? '1px solid #a7a7a7' : 'none',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            position: 'absolute',
                            top: '31px',
                            width: '100%',
                        }}
                        id="map-search-dropdown"
                    >
                        <TextInputWithDropdown
                            points={points.slice(0, 5)}
                            lines={lines.slice(0, 5)}
                            value={searchTerm}
                            onItemClick={handleDropDownItemClick}
                        />
                    </Box>
                )}
            </Form>
        </Box>
    );
};

MapSearchField.defaultProps = {
    currentMap: {},
};

export default injectIntl(MapSearchField);
